import React from "react";
import { Typography } from "@mui/material";

const NavigationDrawerSectionHeader = ({ label, sx = {}, ...props }) => (
  <Typography variant="subtitle2" sx={{ fontWeight: 700, textTransform: 'uppercase', ...sx }} {...props}>
    {label}
  </Typography>
);

export default NavigationDrawerSectionHeader;
